import { render, staticRenderFns } from "./ToolIndex.vue?vue&type=template&id=4c20f3c6&scoped=true&"
import script from "./ToolIndex.vue?vue&type=script&lang=js&"
export * from "./ToolIndex.vue?vue&type=script&lang=js&"
import style0 from "./ToolIndex.vue?vue&type=style&index=0&id=4c20f3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20f3c6",
  null
  
)

export default component.exports